import { schema } from 'normalizr';
import { leadAttributeSchema } from 'store/schemas/leadAttributeSchema';
import { voteSchema } from './voteSchema';

export const leadSchema = new schema.Entity('lead', {
  attributes: leadAttributeSchema,
  currentUserVote: voteSchema,
});
